import { convertQueryToURI } from '@doda/common/src/logics/JobContent/convertQueryToURI';
import { createPreBtn } from '@doda/common/src/logics/JobContent/createPreBtn';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { AppQueryParams } from '@doda/common/src/constants/queryParams';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';
import { HA_QUERY_INFO } from '@doda/common/src/constants/seo/occupationConstants';

/**
 * GenerateOtherPageLinkUrlParams interface
 */
interface GenerateOtherPageLinkUrlParams {
  queryParams: AppQueryParams;
  siteUrl: string;
  preBtn: boolean;
}

/**
 * Generates a link URL based on query parameters and site URL.
 * @param {Object} params - GenerateOtherPageLinkUrlParams.
 * @param {Object} params.queryParams - The query parameters to be converted to a URI.
 * @param {string} params.siteUrl - The base site URL to which the query parameters will be appended.
 * @param {boolean} params.preBtn - A flag indicating whether to use `createPreBtn` on the URI.
 * @returns {string} The generated link URL.
 */
export const generateOtherPageLinkUrl = ({
  queryParams,
  siteUrl,
  preBtn,
}: GenerateOtherPageLinkUrlParams) => {
  if (siteUrl === DODA_SITE_URL.jobRanking) {
    if (queryParams.ci) {
      return '';
    }
  }
  if (siteUrl === DODA_SITE_URL.occupation) {
    const { ha } = queryParams;
    if (!ha || !ha.length) {
      return '';
    }
    if (!Object.keys(HA_QUERY_INFO).includes(ha[0])) {
      return '';
    }
  }
  const uri = convertQueryToURI(queryParams);
  return makeStaticUrl(preBtn ? createPreBtn(uri) : uri, siteUrl);
};
